import { EditorState, convertToRaw, convertFromRaw, Modifier } from "draft-js";
import { DOCUMENTS } from "../../constants";
// Destructuring
const {
  FONT_SIZE_OPTIONS,
  FONT_COLOR_OPTIONS,
  FONT_FAMILY_OPTIONS,
  FONT_WEIGHT_OPTIONS,
} = DOCUMENTS;

const applyFontStyle = (editorState, fontStyle, buttonType) => {
  if (!(fontStyle.startsWith("FONT") && editorState instanceof EditorState))
    return editorState;

  const currentContent = editorState.getCurrentContent();
  const selectionState = editorState.getSelection();

  if (selectionState.isCollapsed()) {
    let styleOptions;
    if (buttonType === "FONTSIZE") {
      styleOptions = FONT_SIZE_OPTIONS;
    }

    if (buttonType === "FONTCOLOR") {
      styleOptions = FONT_COLOR_OPTIONS;
    }

    if (buttonType === "FONTFAMILY") {
      styleOptions = FONT_FAMILY_OPTIONS;
    }

    if (buttonType === "FONTWEIGHT") {
      styleOptions = FONT_WEIGHT_OPTIONS;
    }

    let currentStyle = editorState.getCurrentInlineStyle();
    let removedCurrentStyle = currentStyle;
    Object.keys(styleOptions).forEach(style => {
      if (currentStyle.has(style)) {
        removedCurrentStyle = removedCurrentStyle.remove(style);
      }
    });

    currentStyle = removedCurrentStyle;

    let updatedEditorState = EditorState.setInlineStyleOverride(
      editorState,
      currentStyle,
    );

    updatedEditorState = EditorState.setInlineStyleOverride(
      editorState,
      currentStyle.add(fontStyle),
    );

    return updatedEditorState;
  }

  const startKey = selectionState.getStartKey();
  const endKey = selectionState.getEndKey();
  const startOffset = selectionState.getStartOffset();
  const endOffset = selectionState.getEndOffset();

  const rawState = convertToRaw(currentContent);

  const { blocks, entityMap } = rawState;
  const startIndex = blocks.findIndex(block => block.key === startKey);
  const endIndex = blocks.findIndex(block => block.key === endKey);

  for (let index = startIndex; index <= endIndex; index += 1) {
    const block = blocks[index];
    const { text, key, inlineStyleRanges } = block;
    const startPoint = key === startKey ? startOffset : 0;
    const endPoint = key === endKey ? endOffset : text.length;
    const updatedStylesRanges = [];

    inlineStyleRanges.forEach(range => {
      const { offset, length, style } = range;
      // check if the style is a string
      if (
        (typeof style === "string" &&
          style.split("_")[0] !== fontStyle.split("_")[0]) ||
        (Array.isArray(style) &&
          style.findIndex(s => s.split("_")[0] === fontStyle.split("_")[0]) ===
            -1) ||
        offset > endPoint ||
        offset + length < startPoint
      ) {
        updatedStylesRanges.push(range);
      } else {
        if (startPoint > offset) {
          updatedStylesRanges.push({
            offset,
            length: startPoint - offset,
            style,
          });
        }
        if (offset + length > endPoint) {
          updatedStylesRanges.push({
            offset: endPoint,
            length: offset + length - endPoint,
            style,
          });
        }
      }
    });

    updatedStylesRanges.push({
      offset: startPoint,
      length: endPoint - startPoint,
      style: fontStyle,
    });

    blocks[index] = {
      ...block,
      inlineStyleRanges: updatedStylesRanges,
    };
  }
  let updatedContentState = convertFromRaw({ blocks, entityMap });
  updatedContentState = Modifier.applyInlineStyle(
    updatedContentState,
    selectionState,
    fontStyle,
  );

  const updatedEditorState = EditorState.push(
    editorState,
    updatedContentState,
    "change-inline-style",
  );
  return updatedEditorState;
};

export default applyFontStyle;



// WEBPACK FOOTER //
// ./src/components/CustomRevvToolbar/applyFontStyle.js